import { Http } from "../axios/interceptors";

export const allAgendaPartials = async (param) =>
  Http("GET", `/AgendaPartial/GetByList?`, param);

export const getAgendaPartial = async (guid) =>
  Http("GET", `/AgendaPartial/Get?idAgendaPartial=${guid}`);

export const createOrEditAgendaPartial = async (body, id = null) =>
  id
    ? Http("PUT", `/AgendaPartial/Update`, null, body)
    : Http("POST", "/AgendaPartial/Create", null, body);

export const deleteAgendaPartial = async (guid) =>
  Http("DELETE", `/AgendaPartial/Delete?idAgendaPartial=${guid}`);
